/* Quote Vuex State Management
import { stateQuote, gettersQuote, mutationsQuote, actionsQuote} from './quote'
*/
import axios from '@axios';

export const stateQuote = {
  Quotes: [],
  QuotesTotal: 0,
  Quote: {}
}

export const gettersQuote = {
};

export const mutationsQuote = {
  QUOTE_LIST_SET(state, value) {
    state.Quotes = value.items;
    state.QuotesTotal = value.total;
  },
  QUOTE_ITEM_SET(state, value) {
    state.Quote = value;
  }
};

export const actionsQuote = {
  fetchQuotes(ctx, queryParams) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${ctx.rootState.apiUrl}/api/quotes`, queryParams)
        .then(response => {
          const { items, total } = response.data;
          ctx.commit('QUOTE_LIST_SET', {
            items: items,
            total: total
          });
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  fetchQuote(ctx, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${ctx.rootState.apiUrl}/api/quotes/${id}`)
        .then(response => {
          ctx.commit('QUOTE_ITEM_SET', response.data);
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  updateQuote(ctx, { id, quote }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${ctx.rootState.apiUrl}/api/quotes/${id}`, quote)
        .then(response => {
          ctx.commit('QUOTE_ITEM_SET', response.data);
          ctx.commit('SNACKBAR_ADD', { color: "secondary", message: "Quote saved." });
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
    })
  },
  rejectQuote(ctx, { id, remarks }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${ctx.rootState.apiUrl}/api/quotes/${id}/reject`, { Remarks: remarks })
        .then(response => {
          ctx.commit('QUOTE_ITEM_SET', response.data);
          ctx.commit('SNACKBAR_ADD', { color: "secondary", message: "Quote rejected." });
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
    })
  },
  // price a set of boxes (JSON array of { L, W, H, Qty } in mm) without persisting - used at book-in
  previewVolumetric(ctx, { boxes, isTwoPerson }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${ctx.rootState.apiUrl}/api/quotes/volumetric-preview`, { Boxes: boxes, IsTwoPerson: isTwoPerson || false })
        .then(response => resolve(response.data))
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
    })
  },
  // re-open a converted quote so it can be re-priced (only while it made a single order with an unpaid invoice)
  reopenQuote(ctx, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${ctx.rootState.apiUrl}/api/quotes/${id}/reopen`)
        .then(response => {
          ctx.commit('QUOTE_ITEM_SET', response.data);
          ctx.commit('SNACKBAR_ADD', { color: "secondary", message: "Quote re-opened." });
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
    })
  },
  // abandon a re-quote: the quote's saved pricing is restored and its order's original invoice is payable again
  cancelRequote(ctx, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${ctx.rootState.apiUrl}/api/quotes/${id}/cancel-requote`)
        .then(response => {
          ctx.commit('QUOTE_ITEM_SET', response.data);
          ctx.commit('SNACKBAR_ADD', { color: "secondary", message: "Re-quote cancelled." });
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
    })
  },
  convertQuote(ctx, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${ctx.rootState.apiUrl}/api/quotes/${id}/convert`)
        .then(response => {
          ctx.commit('QUOTE_ITEM_SET', response.data);
          ctx.commit('SNACKBAR_ADD', { color: "success", message: "Quote converted to order." });
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
    })
  }
};
